/**
 * Add-to-cart forms (templates/_components/forms/product/buy-box--*.twig).
 *
 * The form works without JavaScript: it posts to commerce/cart/update-cart and redirects back.
 * With JavaScript it posts in the background, refreshes the mini cart (which listens for
 * `cartUpdated` on the body) and opens the cart drawer.
 *
 * A form with data-track-item (the GA4 item as JSON: item_id, item_name, price, discount) also sends
 * add_to_cart to tracking.js, with the quantity from the form.
 */
window.addToCart = function () {
    return {
        busy: false,
        error: '',
        // Set once the form added something, for a confirmation under the button
        added: false,

        async submit(form) {
            this.error = '';
            this.added = false;

            // Multi-add forms (grouped products) need at least one quantity above 0
            const quantities = [...form.querySelectorAll('input[name$="[qty]"]')];
            if (quantities.length && quantities.every(input => !(Number(input.value) > 0))) {
                this.error = form.dataset.emptyMessage;
                return;
            }

            this.busy = true;

            try {
                const response = await fetch(form.getAttribute('action') || window.location.href, {
                    method: 'POST',
                    headers: { 'Accept': 'application/json' },
                    body: new FormData(form),
                });
                const data = await response.json().catch(() => ({}));

                if (!response.ok) {
                    this.error = data.message || form.dataset.errorMessage;
                    return;
                }

                this.added = true;
                this.trackAddToCart(form);
                document.body.dispatchEvent(new CustomEvent('cartUpdated'));
                document.querySelector('[command="show-modal"][commandfor="drawer--cart"]')?.click();
            } catch (error) {
                this.error = form.dataset.errorMessage;
            } finally {
                this.busy = false;
            }
        },

        trackAddToCart(form) {
            if (!form.dataset.trackItem || !window.track) {
                return;
            }

            // Tracking never gets in the way of the cart itself
            try {
                const item = JSON.parse(form.dataset.trackItem);
                const quantity = Number(form.querySelector('input[name$="qty"]')?.value) || 1;

                window.track({
                    event: 'add_to_cart',
                    ecommerce: {
                        currency: 'EUR',
                        value: Number((item.price * quantity).toFixed(2)),
                        items: [{ ...item, quantity }],
                    },
                });
            } catch (error) {
                console.error('Tracking: invalid data-track-item JSON', error);
            }
        },
    };
};
